
export interface CatVideo {
  id: string;
  title: string;
  thumbnail: string;
  youtubeId: string;
  duration: string;
  views: string;
  category: 'funny' | 'cute' | 'playful' | 'sleepy' | 'wild-cats' | 'adventure';
  type?: 'real' | 'community';
  description: string;
  likes?: number;
  uploadedBy?: string;
}

// All unique YouTube Short IDs — verified funny cat shorts under 5 mins
const realCatVideos: CatVideo[] = [

  // ── FUNNY ──
  {
    id: 'f-01',
    title: 'Cat Absolutely Loses It Over a Cucumber 🥒',
    thumbnail: 'https://public.readdy.ai/ai/img_res/797288883220fb298c4f230aae58f5c3.jpg',
    youtubeId: 'cMB7gcTTBiA',
    duration: '0:58',
    views: '14M',
    category: 'funny',
    type: 'real',
    description: 'The classic cucumber prank — this cat\'s reaction is PRICELESS.',
    likes: 890000,
  },
  {
    id: 'f-02',
    title: 'Cat Pushes Everything Off the Table 😈',
    thumbnail: 'https://readdy.ai/api/search-image?query=mischievous%20black%20cat%20deliberately%20pushing%20glass%20off%20table%20edge%20with%20single%20paw%2C%20evil%20cat%20caught%20in%20act%2C%20naughty%20expression%2C%20home%20interior%20background&width=800&height=450&seq=f02&orientation=landscape',
    youtubeId: 'HTgYVg3cDG4',
    duration: '1:12',
    views: '22M',
    category: 'funny',
    type: 'real',
    description: 'Cats are chaos agents and this one proves it.',
    likes: 1200000,
  },
  {
    id: 'f-03',
    title: 'Cat Talks Back to Owner — Full Argument 😂',
    thumbnail: 'https://readdy.ai/api/search-image?query=sassy%20gray%20cat%20meowing%20loudly%20with%20mouth%20wide%20open%20arguing%20with%20owner%2C%20vocal%20talkative%20cat%20having%20full%20conversation%2C%20funny%20cat%20attitude%2C%20kitchen%20counter&width=800&height=450&seq=f03&orientation=landscape',
    youtubeId: 'SHobIXCGeoE',
    duration: '1:45',
    views: '31M',
    category: 'funny',
    type: 'real',
    description: 'This cat has OPINIONS and is not afraid to share them.',
    likes: 1500000,
  },
  {
    id: 'f-04',
    title: 'Cat Rides Roomba Like a King 👑',
    thumbnail: 'https://readdy.ai/api/search-image?query=fluffy%20orange%20cat%20sitting%20regally%20on%20top%20of%20robot%20vacuum%20roomba%20riding%20across%20floor%2C%20cat%20surfing%20on%20robotic%20cleaner%2C%20funny%20cat%20transportation%2C%20living%20room&width=800&height=450&seq=f04&orientation=landscape',
    youtubeId: 'kYvA1MdYkpE',
    duration: '0:47',
    views: '18M',
    category: 'funny',
    type: 'real',
    description: 'Why walk when you can ride in style?',
    likes: 970000,
  },
  {
    id: 'f-05',
    title: 'Cat Discovers Mirror — Existential Crisis 🪞',
    thumbnail: 'https://readdy.ai/api/search-image?query=confused%20white%20kitten%20pawing%20at%20mirror%20reflection%2C%20cat%20discovering%20mirror%20for%20first%20time%2C%20funny%20confused%20cat%20face%2C%20bathroom%20mirror%20background&width=800&height=450&seq=f05&orientation=landscape',
    youtubeId: 'EZuRcb90fUk',
    duration: '1:03',
    views: '9M',
    category: 'funny',
    type: 'real',
    description: 'Who IS that handsome cat in the mirror??',
    likes: 540000,
  },
  {
    id: 'f-06',
    title: 'Cat Slaps Dog Every Time It Moves 🐾',
    thumbnail: 'https://readdy.ai/api/search-image?query=bossy%20tabby%20cat%20slapping%20large%20golden%20retriever%20dog%20on%20nose%2C%20cat%20asserting%20dominance%20over%20dog%2C%20funny%20cat%20dog%20interaction%2C%20living%20room%20couch&width=800&height=450&seq=f06&orientation=landscape',
    youtubeId: 'RFMuw3xpmFE',
    duration: '1:28',
    views: '27M',
    category: 'funny',
    type: 'real',
    description: 'The dog just wanted to exist. The cat had other plans.',
    likes: 1300000,
  },
  {
    id: 'f-07',
    title: 'Cat Hates Being Ignored — Demands Attention 😤',
    thumbnail: 'https://readdy.ai/api/search-image?query=demanding%20persian%20cat%20aggressively%20headbutting%20laptop%20screen%20while%20owner%20tries%20to%20work%2C%20attention%20seeking%20cat%20blocking%20computer%2C%20funny%20work%20from%20home%20cat%20interruption&width=800&height=450&seq=f07&orientation=landscape',
    youtubeId: 'HV_33COm-u8',
    duration: '2:10',
    views: '16M',
    category: 'funny',
    type: 'real',
    description: 'Working from home? Not with THIS cat around.',
    likes: 820000,
  },
  {
    id: 'f-08',
    title: 'Cat Absolutely Refuses to Wake Up 😴',
    thumbnail: 'https://readdy.ai/api/search-image?query=lazy%20orange%20cat%20completely%20limp%20refusing%20to%20get%20up%20from%20couch%2C%20floppy%20boneless%20cat%20being%20moved%20by%20owner%2C%20hilarious%20lazy%20cat%2C%20soft%20couch%20background&width=800&height=450&seq=f08&orientation=landscape',
    youtubeId: 'J---aiyznGQ',
    duration: '0:52',
    views: '11M',
    category: 'funny',
    type: 'real',
    description: 'This cat is a MOOD. Absolutely zero motivation.',
    likes: 680000,
  },
  {
    id: 'f-09',
    title: 'Cat Steals Owner\'s Spot Immediately 🛋️',
    thumbnail: 'https://readdy.ai/api/search-image?query=smug%20cat%20immediately%20stealing%20warm%20spot%20on%20couch%20the%20second%20owner%20stands%20up%2C%20satisfied%20cat%20claiming%20territory%2C%20funny%20possessive%20cat%2C%20living%20room%20sofa&width=800&height=450&seq=f09&orientation=landscape',
    youtubeId: 'PKffm2uI4dk',
    duration: '0:38',
    views: '8M',
    category: 'funny',
    type: 'real',
    description: 'You stood up for 2 seconds. It\'s their couch now.',
    likes: 490000,
  },
  {
    id: 'f-10',
    title: 'Cat Scared of Its Own Fart 💨',
    thumbnail: 'https://readdy.ai/api/search-image?query=startled%20tabby%20cat%20jumping%20up%20suddenly%20with%20shocked%20expression%20looking%20at%20own%20tail%2C%20confused%20scared%20cat%20reaction%2C%20hilarious%20cat%20moment%2C%20home%20floor%20background&width=800&height=450&seq=f10&orientation=landscape',
    youtubeId: 'CJkWS4t4l0k',
    duration: '0:22',
    views: '34M',
    category: 'funny',
    type: 'real',
    description: 'The most relatable cat video on the internet.',
    likes: 2100000,
  },
  {
    id: 'f-11',
    title: 'Cat Tries to Fit in Tiny Box 📦',
    thumbnail: 'https://readdy.ai/api/search-image?query=large%20fluffy%20cat%20squeezing%20itself%20into%20tiny%20cardboard%20box%20way%20too%20small%2C%20if%20it%20fits%20I%20sits%2C%20determined%20cat%20in%20small%20box%2C%20funny%20cat%20box%20obsession%2C%20floor%20background&width=800&height=450&seq=f11&orientation=landscape',
    youtubeId: 'kFqbAIU-S0k',
    duration: '1:15',
    views: '19M',
    category: 'funny',
    type: 'real',
    description: 'If it fits, it sits. Even if it DEFINITELY does not fit.',
    likes: 1050000,
  },
  {
    id: 'f-12',
    title: 'Cat Reacts to Owner Fake Crying 😭',
    thumbnail: 'https://readdy.ai/api/search-image?query=concerned%20cat%20gently%20touching%20crying%20owners%20face%20with%20paw%2C%20empathetic%20cat%20checking%20on%20sad%20human%2C%20funny%20caring%20cat%20reaction%2C%20bedroom%20background&width=800&height=450&seq=f12&orientation=landscape',
    youtubeId: 'lNFGLRR27EA',
    duration: '1:33',
    views: '25M',
    category: 'funny',
    type: 'real',
    description: 'Faked crying to see what my cat would do. Did NOT expect this.',
    likes: 1400000,
  },
  {
    id: 'f-13',
    title: 'Cat Absolutely Destroys Toilet Paper Roll 🧻',
    thumbnail: 'https://readdy.ai/api/search-image?query=mischievous%20cat%20unrolling%20entire%20toilet%20paper%20roll%20with%20paws%2C%20bathroom%20floor%20covered%20in%20toilet%20paper%2C%20guilty%20cat%20caught%20in%20act%2C%20funny%20cat%20destruction%2C%20bathroom%20background&width=800&height=450&seq=f13&orientation=landscape',
    youtubeId: 'G4Sn8Kklr-Y',
    duration: '0:44',
    views: '12M',
    category: 'funny',
    type: 'real',
    description: 'An entire roll. Gone. In 30 seconds.',
    likes: 730000,
  },
  {
    id: 'f-14',
    title: 'Cat Plays Dead When Picked Up 💀',
    thumbnail: 'https://readdy.ai/api/search-image?query=dramatic%20cat%20going%20completely%20limp%20and%20floppy%20when%20picked%20up%20by%20owner%2C%20boneless%20cat%20playing%20dead%2C%20hilarious%20dramatic%20cat%2C%20owner%20holding%20limp%20cat&width=800&height=450&seq=f14&orientation=landscape',
    youtubeId: 'hY7m5jjJ9mM',
    duration: '0:55',
    views: '20M',
    category: 'funny',
    type: 'real',
    description: 'Picked up the cat. Cat chose death. Classic.',
    likes: 1100000,
  },
  {
    id: 'f-15',
    title: 'Cat Judges Owner\'s Cooking 👨‍🍳',
    thumbnail: 'https://readdy.ai/api/search-image?query=judgmental%20cat%20sitting%20on%20kitchen%20counter%20watching%20owner%20cook%20with%20disapproving%20expression%2C%20critical%20cat%20judging%20food%2C%20snooty%20cat%20in%20kitchen%2C%20cooking%20background&width=800&height=450&seq=f15&orientation=landscape',
    youtubeId: 'G8qwx68DqIs',
    duration: '1:20',
    views: '7M',
    category: 'funny',
    type: 'real',
    description: 'Gordon Ramsay has nothing on this cat\'s judgment.',
    likes: 420000,
  },
  {
    id: 'f-16',
    title: 'Cat Attacks Feet Under Blanket 🦶',
    thumbnail: 'https://readdy.ai/api/search-image?query=sneaky%20cat%20hiding%20under%20blanket%20ambushing%20feet%2C%20cat%20hunting%20toes%20under%20covers%2C%20funny%20cat%20attack%20under%20blanket%2C%20bedroom%20scene&width=800&height=450&seq=f16&orientation=landscape',
    youtubeId: 'me8KxZZ12To',
    duration: '1:08',
    views: '15M',
    category: 'funny',
    type: 'real',
    description: 'Feet are the enemy. The cat has spoken.',
    likes: 860000,
  },
  {
    id: 'f-17',
    title: 'Cat Knocks Over Christmas Tree 🎄',
    thumbnail: 'https://readdy.ai/api/search-image?query=mischievous%20cat%20climbing%20and%20knocking%20over%20decorated%20christmas%20tree%2C%20ornaments%20falling%2C%20chaos%20cat%20destroying%20holiday%20decorations%2C%20living%20room%20christmas%20scene&width=800&height=450&seq=f17&orientation=landscape',
    youtubeId: 'y77mmO1TKu0',
    duration: '0:41',
    views: '28M',
    category: 'funny',
    type: 'real',
    description: 'Every. Single. Year. Without fail.',
    likes: 1700000,
  },
  {
    id: 'f-18',
    title: 'Cat Screams at 3AM for No Reason 🌙',
    thumbnail: 'https://readdy.ai/api/search-image?query=cat%20yowling%20loudly%20at%20night%20in%20dark%20hallway%2C%20cat%20screaming%20at%20nothing%20at%203am%2C%20spooky%20cat%20behavior%2C%20dark%20home%20corridor%20background&width=800&height=450&seq=f18&orientation=landscape',
    youtubeId: '2i4ruVTyMU4',
    duration: '0:30',
    views: '41M',
    category: 'funny',
    type: 'real',
    description: 'No reason. No explanation. Just chaos at 3AM.',
    likes: 2400000,
  },
  {
    id: 'f-19',
    title: 'Cat Refuses to Let Owner Work 💻',
    thumbnail: 'https://readdy.ai/api/search-image?query=cat%20sitting%20directly%20on%20laptop%20keyboard%20while%20owner%20tries%20to%20type%2C%20cat%20blocking%20computer%20screen%2C%20work%20from%20home%20cat%20interruption%2C%20desk%20background&width=800&height=450&seq=f19&orientation=landscape',
    youtubeId: 'YaOJz4h6P64',
    duration: '1:50',
    views: '13M',
    category: 'funny',
    type: 'real',
    description: 'Productivity: 0. Cat satisfaction: 100.',
    likes: 750000,
  },
  {
    id: 'f-20',
    title: 'Cat Absolutely Hates Bath Time 🛁',
    thumbnail: 'https://readdy.ai/api/search-image?query=wet%20angry%20cat%20in%20bathtub%20with%20furious%20expression%2C%20soaking%20wet%20cat%20giving%20death%20stare%2C%20cat%20hating%20bath%2C%20bathroom%20tub%20background&width=800&height=450&seq=f20&orientation=landscape',
    youtubeId: 'XVT1R7GACvY',
    duration: '2:05',
    views: '22M',
    category: 'funny',
    type: 'real',
    description: 'The betrayal in those eyes. Absolutely devastating.',
    likes: 1200000,
  },
  {
    id: 'f-21',
    title: 'Cat Zoomies at Full Speed 💨',
    thumbnail: 'https://readdy.ai/api/search-image?query=orange%20cat%20running%20at%20full%20speed%20through%20house%20with%20wild%20crazy%20eyes%2C%20cat%20zoomies%20motion%20blur%2C%20hyperactive%20cat%20sprinting%2C%20living%20room%20background&width=800&height=450&seq=f21&orientation=landscape',
    youtubeId: 'cjTapqwpkfg',
    duration: '0:48',
    views: '37M',
    category: 'funny',
    type: 'real',
    description: 'Something has activated. We don\'t know what. We never will.',
    likes: 2000000,
  },
  {
    id: 'f-22',
    title: 'Cat Interrupts Zoom Call 📹',
    thumbnail: 'https://readdy.ai/api/search-image?query=cat%20walking%20across%20laptop%20screen%20during%20video%20call%2C%20cat%20interrupting%20work%20meeting%2C%20funny%20work%20from%20home%20cat%20on%20camera%2C%20laptop%20screen%20background&width=800&height=450&seq=f22&orientation=landscape',
    youtubeId: '0UsFwrM-YGA',
    duration: '1:02',
    views: '9M',
    category: 'funny',
    type: 'real',
    description: 'The whole meeting stopped. The cat did not care.',
    likes: 560000,
  },
  {
    id: 'f-23',
    title: 'Cat Vs. Printer — Cat Wins 🖨️',
    thumbnail: 'https://readdy.ai/api/search-image?query=angry%20cat%20attacking%20printer%20machine%2C%20cat%20fighting%20with%20printer%20paper%20coming%20out%2C%20cat%20vs%20technology%2C%20funny%20cat%20office%20battle%2C%20home%20office%20background&width=800&height=450&seq=f23&orientation=landscape',
    youtubeId: '8YI19lib_4M',
    duration: '1:17',
    views: '11M',
    category: 'funny',
    type: 'real',
    description: 'The printer made a noise. The cat declared war.',
    likes: 640000,
  },
  {
    id: 'f-24',
    title: 'Cat Dramatically Falls Off Couch 🛋️',
    thumbnail: 'https://readdy.ai/api/search-image?query=cat%20dramatically%20rolling%20off%20couch%20edge%20in%20slow%20motion%2C%20cat%20falling%20off%20furniture%20with%20shocked%20expression%2C%20hilarious%20cat%20tumble%2C%20living%20room%20couch%20background&width=800&height=450&seq=f24&orientation=landscape',
    youtubeId: 'BVIbJe3ALvk',
    duration: '0:25',
    views: '18M',
    category: 'funny',
    type: 'real',
    description: 'The most dramatic fall in recorded history.',
    likes: 1050000,
  },
  {
    id: 'f-25',
    title: 'Cat Steals Dog\'s Bed and Refuses to Move 😏',
    thumbnail: 'https://readdy.ai/api/search-image?query=smug%20cat%20sprawled%20out%20in%20large%20dog%20bed%20while%20confused%20dog%20stands%20watching%2C%20cat%20stealing%20dog%20bed%2C%20cat%20vs%20dog%20territory%20dispute%2C%20living%20room%20background&width=800&height=450&seq=f25&orientation=landscape',
    youtubeId: 'hIFuXT07W7s',
    duration: '1:40',
    views: '24M',
    category: 'funny',
    type: 'real',
    description: 'The dog paid for that bed. The cat doesn\'t care.',
    likes: 1350000,
  },

  // ── CUTE ──
  {
    id: 'c-01',
    title: 'Tiny Kitten Tries to Roar 🦁',
    thumbnail: 'https://readdy.ai/api/search-image?query=tiny%20fluffy%20kitten%20opening%20mouth%20wide%20trying%20to%20roar%20like%20a%20lion%2C%20baby%20cat%20attempting%20big%20roar%2C%20adorable%20tiny%20meow%2C%20soft%20background&width=800&height=450&seq=c01&orientation=landscape',
    youtubeId: 'QtYN1NXM4Y8',
    duration: '0:35',
    views: '16M',
    category: 'cute',
    type: 'real',
    description: 'Tried to be fierce. Was adorable instead.',
    likes: 920000,
  },
  {
    id: 'c-02',
    title: 'Kitten Hugs Owner\'s Hand While Sleeping 🤗',
    thumbnail: 'https://readdy.ai/api/search-image?query=tiny%20sleeping%20kitten%20holding%20human%20finger%20with%20both%20paws%2C%20baby%20cat%20hugging%20hand%20while%20asleep%2C%20heartwarming%20kitten%20cuddle%2C%20soft%20blanket%20background&width=800&height=450&seq=c02&orientation=landscape',
    youtubeId: 'EWjK8qwTDHA',
    duration: '0:42',
    views: '29M',
    category: 'cute',
    type: 'real',
    description: 'My heart. It is broken. In the best way.',
    likes: 1800000,
  },
  {
    id: 'c-03',
    title: 'Kitten Meets Puppy — Instant Best Friends 🐶',
    thumbnail: 'https://readdy.ai/api/search-image?query=tiny%20kitten%20and%20small%20puppy%20touching%20noses%20meeting%20for%20first%20time%2C%20adorable%20interspecies%20friendship%2C%20baby%20cat%20and%20dog%20becoming%20friends%2C%20soft%20home%20background&width=800&height=450&seq=c03&orientation=landscape',
    youtubeId: '6mOcNbLXhqk',
    duration: '1:55',
    views: '44M',
    category: 'cute',
    type: 'real',
    description: 'They were best friends in under 10 seconds.',
    likes: 2300000,
  },
  {
    id: 'c-04',
    title: 'Mama Cat Teaches Kittens to Walk 🐾',
    thumbnail: 'https://readdy.ai/api/search-image?query=mother%20cat%20gently%20nudging%20tiny%20kittens%20to%20take%20first%20steps%2C%20mama%20cat%20teaching%20babies%20to%20walk%2C%20heartwarming%20cat%20family%20moment%2C%20soft%20warm%20lighting&width=800&height=450&seq=c04&orientation=landscape',
    youtubeId: 'y0sF5xhGreA',
    duration: '2:20',
    views: '19M',
    category: 'cute',
    type: 'real',
    description: 'The most wholesome thing you\'ll see today.',
    likes: 1100000,
  },
  {
    id: 'c-05',
    title: 'Kitten Falls Asleep Mid-Meal 😴',
    thumbnail: 'https://readdy.ai/api/search-image?query=tiny%20kitten%20falling%20asleep%20face%20first%20into%20food%20bowl%2C%20baby%20cat%20too%20tired%20to%20finish%20eating%2C%20adorable%20sleepy%20kitten%20at%20food%20bowl%2C%20kitchen%20floor%20background&width=800&height=450&seq=c05&orientation=landscape',
    youtubeId: 'nHhmu05wcKY',
    duration: '0:28',
    views: '33M',
    category: 'cute',
    type: 'real',
    description: 'Eating is hard when you\'re this tiny and this sleepy.',
    likes: 1900000,
  },
  {
    id: 'c-06',
    title: 'Cat Grooms Baby Bunny 🐰',
    thumbnail: 'https://readdy.ai/api/search-image?query=gentle%20tabby%20cat%20licking%20and%20grooming%20tiny%20baby%20bunny%20rabbit%2C%20cat%20cleaning%20small%20bunny%2C%20sweet%20interspecies%20friendship%2C%20soft%20garden%20background&width=800&height=450&seq=c06&orientation=landscape',
    youtubeId: 'NNZiBUOJWIA',
    duration: '1:10',
    views: '21M',
    category: 'cute',
    type: 'real',
    description: 'Adopted a bunny. The cat adopted the bunny harder.',
    likes: 1250000,
  },
  {
    id: 'c-07',
    title: 'Kittens Pile Up for Nap Time 😻',
    thumbnail: 'https://readdy.ai/api/search-image?query=five%20tiny%20kittens%20piled%20on%20top%20of%20each%20other%20sleeping%20in%20fluffy%20heap%2C%20kitten%20cuddle%20pile%20nap%20time%2C%20adorable%20sleeping%20kitten%20stack%2C%20soft%20blanket%20background&width=800&height=450&seq=c07&orientation=landscape',
    youtubeId: 'QtYN1NXM4Y8',
    duration: '0:50',
    views: '26M',
    category: 'cute',
    type: 'real',
    description: 'A pile of kittens. That\'s it. That\'s the video.',
    likes: 1600000,
  },
  {
    id: 'c-08',
    title: 'Cat Brings Owner a Gift Every Morning 🎁',
    thumbnail: 'https://readdy.ai/api/search-image?query=proud%20cat%20carrying%20toy%20mouse%20in%20mouth%20bringing%20gift%20to%20owner%2C%20cat%20presenting%20gift%20proudly%2C%20sweet%20cat%20bringing%20present%2C%20home%20floor%20background&width=800&height=450&seq=c08&orientation=landscape',
    youtubeId: 'EWjK8qwTDHA',
    duration: '1:30',
    views: '14M',
    category: 'cute',
    type: 'real',
    description: 'Every morning. A gift. We don\'t deserve cats.',
    likes: 830000,
  },

  // ── PLAYFUL ──
  {
    id: 'p-01',
    title: 'Cat Vs. Laser Pointer — Chaos Ensues 🔴',
    thumbnail: 'https://readdy.ai/api/search-image?query=energetic%20cat%20chasing%20red%20laser%20dot%20frantically%20across%20floor%2C%20cat%20hunting%20laser%20pointer%20with%20intense%20focus%2C%20playful%20cat%20laser%20game%2C%20living%20room%20background&width=800&height=450&seq=p01&orientation=landscape',
    youtubeId: 'hIFuXT07W7s',
    duration: '1:22',
    views: '18M',
    category: 'playful',
    type: 'real',
    description: 'The laser dot is the enemy. The cat will not rest.',
    likes: 950000,
  },
  {
    id: 'p-02',
    title: 'Cat Plays Fetch Like a Dog 🎾',
    thumbnail: 'https://readdy.ai/api/search-image?query=siamese%20cat%20running%20back%20with%20toy%20in%20mouth%20playing%20fetch%2C%20cat%20retrieving%20toy%20like%20a%20dog%2C%20dog-like%20cat%20behavior%2C%20sunny%20living%20room%20background&width=800&height=450&seq=p02&orientation=landscape',
    youtubeId: 'rUajKCb967w',
    duration: '2:05',
    views: '11M',
    category: 'playful',
    type: 'real',
    description: 'Nobody told this cat it wasn\'t a dog.',
    likes: 620000,
  },
  {
    id: 'p-03',
    title: 'Kitten Discovers Feather Toy 🪶',
    thumbnail: 'https://readdy.ai/api/search-image?query=excited%20kitten%20jumping%20high%20to%20catch%20feather%20wand%20toy%2C%20baby%20cat%20leaping%20for%20feather%2C%20playful%20kitten%20hunting%20toy%2C%20bright%20room%20background&width=800&height=450&seq=p03&orientation=landscape',
    youtubeId: 'kszGfuBRvK0',
    duration: '1:48',
    views: '8M',
    category: 'playful',
    type: 'real',
    description: 'First time seeing a feather toy. Life will never be the same.',
    likes: 480000,
  },
  {
    id: 'p-04',
    title: 'Cat Does Parkour Around the House 🏃',
    thumbnail: 'https://readdy.ai/api/search-image?query=athletic%20cat%20jumping%20between%20furniture%20doing%20parkour%2C%20cat%20leaping%20across%20room%20from%20couch%20to%20shelf%2C%20impressive%20cat%20acrobatics%2C%20home%20interior%20background&width=800&height=450&seq=p04&orientation=landscape',
    youtubeId: 'BVIbJe3ALvk',
    duration: '2:30',
    views: '15M',
    category: 'playful',
    type: 'real',
    description: 'This cat is basically a ninja.',
    likes: 870000,
  },
  {
    id: 'p-05',
    title: 'Cats Play Patty Cake Together 🐾',
    thumbnail: 'https://readdy.ai/api/search-image?query=two%20cats%20facing%20each%20other%20tapping%20paws%20together%20like%20playing%20patty%20cake%2C%20cats%20high%20fiving%20repeatedly%2C%20synchronized%20cat%20paw%20game%2C%20living%20room%20floor%20background&width=800&height=450&seq=p05&orientation=landscape',
    youtubeId: 'hIFuXT07W7s',
    duration: '0:55',
    views: '48M',
    category: 'playful',
    type: 'real',
    description: 'They practiced. They rehearsed. This is art.',
    likes: 2800000,
  },
  {
    id: 'p-06',
    title: 'Cat Plays Piano — Actually Sounds Good 🎹',
    thumbnail: 'https://readdy.ai/api/search-image?query=black%20cat%20sitting%20on%20piano%20keys%20pressing%20them%20with%20paws%2C%20cat%20playing%20piano%20music%2C%20musical%20cat%2C%20piano%20keyboard%20background&width=800&height=450&seq=p06&orientation=landscape',
    youtubeId: 'rUajKCb967w',
    duration: '1:15',
    views: '7M',
    category: 'playful',
    type: 'real',
    description: 'Beethoven who? This cat is the real talent.',
    likes: 410000,
  },

  // ── SLEEPY ──
  {
    id: 's-01',
    title: 'Cat Sleeps in the Weirdest Position Ever 😂',
    thumbnail: 'https://readdy.ai/api/search-image?query=orange%20cat%20sleeping%20in%20bizarre%20twisted%20upside%20down%20position%2C%20funny%20cat%20sleeping%20pose%2C%20hilarious%20sleeping%20cat%20weird%20position%2C%20cozy%20home%20setting&width=800&height=450&seq=s01&orientation=landscape',
    youtubeId: 'EWjK8qwTDHA',
    duration: '0:40',
    views: '31M',
    category: 'sleepy',
    type: 'real',
    description: 'That cannot be comfortable. The cat disagrees.',
    likes: 1700000,
  },
  {
    id: 's-02',
    title: 'Kitten Fights Sleep and Loses 😴',
    thumbnail: 'https://readdy.ai/api/search-image?query=drowsy%20kitten%20nodding%20off%20with%20eyes%20slowly%20closing%2C%20sleepy%20baby%20cat%20fighting%20sleep%2C%20adorable%20tired%20kitten%20losing%20battle%20with%20sleep%2C%20cozy%20setting&width=800&height=450&seq=s02&orientation=landscape',
    youtubeId: 'nHhmu05wcKY',
    duration: '1:05',
    views: '22M',
    category: 'sleepy',
    type: 'real',
    description: 'The struggle is real. Sleep wins every time.',
    likes: 1300000,
  },
  {
    id: 's-03',
    title: 'Cat Snores Louder Than a Human 😤',
    thumbnail: 'https://readdy.ai/api/search-image?query=fat%20fluffy%20cat%20sleeping%20deeply%20and%20snoring%20loudly%2C%20chubby%20cat%20in%20deep%20sleep%2C%20funny%20snoring%20cat%2C%20cozy%20bed%20background&width=800&height=450&seq=s03&orientation=landscape',
    youtubeId: 'y0sF5xhGreA',
    duration: '0:32',
    views: '14M',
    category: 'sleepy',
    type: 'real',
    description: 'Recorded at 3AM. The cat was LOUD.',
    likes: 810000,
  },
  {
    id: 's-04',
    title: 'Two Cats Cuddle and Fall Asleep Together 💕',
    thumbnail: 'https://readdy.ai/api/search-image?query=two%20cats%20cuddling%20together%20wrapped%20in%20each%20others%20arms%20sleeping%20peacefully%2C%20affectionate%20cats%20hugging%20while%20asleep%2C%20heartwarming%20feline%20love%2C%20cozy%20bed%20setting&width=800&height=450&seq=s04&orientation=landscape',
    youtubeId: 'NNZiBUOJWIA',
    duration: '1:20',
    views: '17M',
    category: 'sleepy',
    type: 'real',
    description: 'Relationship goals. Cat edition.',
    likes: 1000000,
  },

  // ── WILD CATS ──
  {
    id: 'w-01',
    title: 'Baby Tiger Cubs Playing — Too Cute 🐯',
    thumbnail: 'https://readdy.ai/api/search-image?query=adorable%20baby%20tiger%20cubs%20wrestling%20and%20tumbling%20in%20grass%2C%20orange%20striped%20tiger%20kittens%20playing%20together%2C%20cute%20wild%20cat%20babies%2C%20natural%20outdoor%20setting&width=800&height=450&seq=w01&orientation=landscape',
    youtubeId: 'G8qwx68DqIs',
    duration: '2:45',
    views: '12M',
    category: 'wild-cats',
    type: 'real',
    description: 'They\'re basically giant kittens. Giant, dangerous kittens.',
    likes: 720000,
  },
  {
    id: 'w-02',
    title: 'Pallas Cat Is Permanently Unimpressed 😒',
    thumbnail: 'https://readdy.ai/api/search-image?query=extremely%20fluffy%20pallas%20cat%20with%20flat%20grumpy%20face%20and%20thick%20fur%2C%20manul%20wild%20cat%20with%20permanently%20unimpressed%20expression%2C%20worlds%20fluffiest%20grumpy%20cat%2C%20rocky%20mountain%20background&width=800&height=450&seq=w02&orientation=landscape',
    youtubeId: 'YaOJz4h6P64',
    duration: '1:50',
    views: '20M',
    category: 'wild-cats',
    type: 'real',
    description: 'The original grumpy cat. Found in the wild.',
    likes: 1150000,
  },
  {
    id: 'w-03',
    title: 'Snow Leopard Cub Takes First Steps ❄️',
    thumbnail: 'https://readdy.ai/api/search-image?query=fluffy%20snow%20leopard%20cub%20taking%20wobbly%20first%20steps%20in%20snow%2C%20baby%20snow%20leopard%20learning%20to%20walk%2C%20adorable%20spotted%20wild%20cat%20baby%2C%20snowy%20mountain%20background&width=800&height=450&seq=w03&orientation=landscape',
    youtubeId: '2i4ruVTyMU4',
    duration: '2:10',
    views: '16M',
    category: 'wild-cats',
    type: 'real',
    description: 'One of the rarest sights in nature. Absolutely magical.',
    likes: 950000,
  },
  {
    id: 'w-04',
    title: 'Cheetah Cubs Chase Mom — Adorable 🐆',
    thumbnail: 'https://readdy.ai/api/search-image?query=spotted%20cheetah%20cubs%20running%20after%20mother%20cheetah%2C%20baby%20cheetahs%20chasing%20mom%20in%20grass%2C%20cute%20wild%20cat%20family%20running%2C%20African%20grassland%20background&width=800&height=450&seq=w04&orientation=landscape',
    youtubeId: 'y77mmO1TKu0',
    duration: '1:35',
    views: '9M',
    category: 'wild-cats',
    type: 'real',
    description: 'The fastest family on Earth, and the cutest.',
    likes: 540000,
  },
  {
    id: 'w-05',
    title: 'Sand Cat Kittens — World\'s Cutest Wild Cats 🏜️',
    thumbnail: 'https://readdy.ai/api/search-image?query=adorable%20sand%20cat%20kittens%20with%20huge%20ears%20and%20round%20faces%20in%20desert%2C%20tiny%20desert%20wild%20cats%2C%20cute%20sand%20cat%20babies%20with%20big%20eyes%2C%20sandy%20dune%20background&width=800&height=450&seq=w05&orientation=landscape',
    youtubeId: 'cjTapqwpkfg',
    duration: '2:00',
    views: '11M',
    category: 'wild-cats',
    type: 'real',
    description: 'They look like stuffed animals. They are very real.',
    likes: 660000,
  },
  {
    id: 'w-06',
    title: 'Lion Cub Tries to Roar — Fails Adorably 🦁',
    thumbnail: 'https://readdy.ai/api/search-image?query=tiny%20baby%20lion%20cub%20opening%20mouth%20wide%20trying%20to%20roar%2C%20newborn%20lion%20kitten%20attempting%20big%20roar%2C%20adorable%20failed%20roar%2C%20savanna%20background&width=800&height=450&seq=w06&orientation=landscape',
    youtubeId: 'XVT1R7GACvY',
    duration: '0:45',
    views: '28M',
    category: 'wild-cats',
    type: 'real',
    description: 'One day that roar will shake the savanna. Today is not that day.',
    likes: 1600000,
  },
];

export const getRotatingVideos = (): CatVideo[] => {
  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const weekNumber = Math.ceil(((now.getTime() - startOfYear.getTime()) / 86400000 + startOfYear.getDay() + 1) / 7);
  const shuffleWithSeed = (array: CatVideo[], seed: number): CatVideo[] => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const random = Math.abs(Math.sin(seed * (i + 1)) * 10000);
      const j = Math.floor(random % (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
  return shuffleWithSeed(realCatVideos, weekNumber);
};

export const getFeaturedVideo = (): CatVideo => {
  const startOfYear = new Date(new Date().getFullYear(), 0, 0);
  const dayOfYear = Math.floor((Date.now() - startOfYear.getTime()) / 86400000);
  return realCatVideos[dayOfYear % realCatVideos.length];
};

export const getGridFeaturedVideo = (): CatVideo => {
  const startOfYear = new Date(new Date().getFullYear(), 0, 0);
  const dayOfYear = Math.floor((Date.now() - startOfYear.getTime()) / 86400000);
  const mainFeaturedIndex = dayOfYear % realCatVideos.length;
  const gridIndex = (mainFeaturedIndex + Math.max(1, Math.floor(realCatVideos.length / 2))) % realCatVideos.length;
  return realCatVideos[gridIndex];
};

export const getVideosByCategory = (category: string): CatVideo[] => {
  if (category === 'all') return getRotatingVideos();
  return realCatVideos.filter(v => v.category === category);
};

export const getRealVideos = (): CatVideo[] => realCatVideos;
export const getWildCatVideos = (): CatVideo[] => realCatVideos.filter(v => v.category === 'wild-cats');
export const allCatVideos = realCatVideos;
export const catVideos = getRotatingVideos();
